import { Phone, ShoppingBag, MapPin, Instagram, Facebook } from "lucide-react";
import { TAVERN } from "../../data/tavern";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="wood-panel relative text-[#F4E9D8]"
    >
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 md:grid-cols-3 md:gap-12 md:px-8 md:py-20">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full">
              <img
                src={TAVERN.logo}
                alt=""
                className="h-full w-full object-contain"
              />
            </span>
            <span className="font-display text-2xl font-black tracking-tight text-white">
              {TAVERN.name}
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#F4E9D8]/75">
            Παραδοσιακή ταβέρνα στην καρδιά της Καβάλας. Αυθεντικές γεύσεις,
            ζεστή φιλοξενία και αγάπη σε κάθε πιάτο.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <a
              href={TAVERN.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="social-instagram"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/80 transition-colors hover:border-[#F4C96B] hover:text-[#F4C96B]"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={TAVERN.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              data-testid="social-facebook"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white/80 transition-colors hover:border-[#F4C96B] hover:text-[#F4C96B]"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>

        {/* Contact */}
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#F4C96B]">
            ΕΠΙΚΟΙΝΩΝΙΑ
          </p>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 text-[#F4C96B]" />
              <a
                href={`tel:${TAVERN.phoneTel}`}
                data-testid="footer-phone"
                className="text-base font-semibold text-white hover:text-[#F4C96B]"
              >
                {TAVERN.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 text-[#F4C96B]" />
              <span className="text-[#F4E9D8]/85">{TAVERN.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <ShoppingBag className="mt-0.5 h-4 w-4 text-[#F4C96B]" />
              <a
                href={TAVERN.efoodUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-efood"
                className="text-[#F4E9D8]/85 hover:text-[#F4C96B]"
              >
                Παραγγελία μέσω e-food
              </a>
            </li>
          </ul>
        </div>

        {/* Quick nav */}
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#F4C96B]">
            ΠΛΟΗΓΗΣΗ
          </p>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <a
                href="#menu"
                className="text-[#F4E9D8]/85 hover:text-[#F4C96B]"
              >
                Μενού
              </a>
            </li>
            <li>
              <a
                href="#gallery"
                className="text-[#F4E9D8]/85 hover:text-[#F4C96B]"
              >
                Γκαλερί
              </a>
            </li>
            <li>
              <a
                href="#location"
                className="text-[#F4E9D8]/85 hover:text-[#F4C96B]"
              >
                Τοποθεσία & Ώρες
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 md:flex-row md:px-8">
          <p className="text-xs text-[#F4E9D8]/60">
            © {new Date().getFullYear()} {TAVERN.name}. Όλα τα δικαιώματα
            διατηρούνται.
          </p>
          <p className="text-xs text-[#F4E9D8]/60">
            Φτιαγμένο με μεράκι στην Καβάλα.
          </p>
        </div>
      </div>
    </footer>
  );
}
